import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/Service/Common.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RestApiService } from 'src/app/Service/rest-api.service';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { DocumentViewerService } from 'src/app/Service/documentviewer/documentviewer.service';
import { FileService, FileUploadLibrary } from 'src/app/Service/file/file.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';

@Component({
  selector: 'eip-file-upload',
  templateUrl: './file-upload.component.html',
  styles: [`
    .file-upload {
      color: white;
      border-radius: 21.5px;
      background-color: #1579ab;
      cursor: pointer;
      padding:7px 20px;
      margin-bottom:15px;
    }
    .btn-upload{

    padding: 3px 7px;
    }
    .container {

      padding: 15px;
      text-align: center;
      border: dashed 1px #979797;
      position: relative;
      margin: 0 auto;
     }
.fs-40
{
  font-size:40px;
}
.fs-25
{
  font-size:25px;
}
     .file-display {
      margin-top: 10px;
      padding-bottom: 5px;
      border: dashed 1px black;
      //width: 800px;
      max-height: 160px;
      overflow: scroll;
    }

    .notification {
      line-height: 10px;
      font-size: 14px;
      color: red;
    }

    .dialog-box-header{
      font-size: 18px;
      line-height: 1.3em;
    }
  `]
})

export class FileUploadComponent implements OnInit {
  public isDialogOpen: boolean = false;
  public isfileUpload: boolean = false;
  public fileTypeList: RoleFeatureModel[] = [];
  public documentList: Array<any> = new Array<any>();
  public fileCollection: Array<any> = new Array<any>();
  public fileCollectionStack: Array<any> = new Array<any>();
  public fileCollectionValidation: Array<any> = new Array<any>();
  public fileAccepts: string = environment.fileTypeAccepts;
  isTranslationRequired!: boolean;
  isDocumentListDisabled: boolean = false;
  selecteDocument!: number[];
  libraryNumber!: number;
  libraryName!: string;
  enableFullscreen = false;
  setWidth: any = 130;
  public selectedFileList: any;
  public canAutoMapList: any;

  drawingFileFormats: string[] = ['dwg', 'rvt', 'nwd', '3dm', 'dwf', 'dxf', 'dwfx', 'dwt', 'rfa', 'ifc', 'nwc', 'rte']
  private headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'Authorization': 'Bearer ' + this.commonService.getJWT(),
    'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
  }

  private uris = {
    dedAgainstDEGetUrl: "DEDED/GetCommonDEDAgainstDE"
  };

  @Output() public onUploadFinished = new EventEmitter();

  constructor(private restAPIService: RestApiService, private encryptDecryptService: EncryptDecryptService, private commonService: CommonService,
    private http: HttpClient, private loaderService: LoaderService, private _docViewerService: DocumentViewerService, @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FileUploadComponent>, private _fileService: FileService, private _notificationService: NotificationService) {
  }

  ngOnInit() {
    this.getFileType();
    if (!!this.data) {
      this.libraryNumber = this.data['libraryName'];
      this.isTranslationRequired = this.libraryNumber == FileUploadLibrary.Documents || this.libraryNumber == FileUploadLibrary.WorkflowDocument;
      this.libraryName = FileUploadLibrary[this.libraryNumber];
      this.documentList = this.data['documents'];
      this.isDocumentListDisabled = Boolean(this.data['isEditable']);
      this.selecteDocument = this.documentList.length <= 1 ? this.documentList[0]['value'] : null;
      this.selectedFileList = this.data['documents'];
      if(this.data['isEnableFullScreen'])
      {
        this.enableFullscreen = this.data['isEnableFullScreen'];
      }
    }
    else {
      this._notificationService.showPopup("Invalid configuration", "Warning");
      this.dialogRef.close();
    }
  }

  public togglePopupDialog() {
    this.fileCollection = new Array<any>();
    this.fileCollectionStack = new Array<any>();
    this.fileCollectionValidation = new Array<any>();
    this.dialogRef.close();
  }

  public onFileDropped($event: any) {
    this.file_onChange($event, false);
  }

  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
    if (this.enableFullscreen) {
      this.setWidth = 350;
    }
    else {
      this.setWidth = 130;
    }
  }

  public file_onChange = async (files: any, isFlushArray: any) => {
    if (files.length === 0)
      return;
    let fileList = Array.from(files);
    let fileAccepts = this.fileAccepts.split(',');
    this.autoMapDocuments(files,this.documentList);
    for (let index = 0; index < fileList.length; index++) {
      let file: any = fileList[index];
      let fileName: string = file['name'];
      let fileExtn: string = fileName.substring(fileName.lastIndexOf('.'));
      let isValidFile: boolean = fileAccepts.includes(fileExtn.toLowerCase());

      if (file['size'] === 0)
        fileList.splice(index, 1);

      if (!isValidFile)
        fileList.splice(index, 1);
    }

    if (fileList.length === 0) {
      this._notificationService.showPopup("Upload valid file with valid name", "Warning");
      return;
    }

    if (isFlushArray) {
      this.fileCollection = new Array<any>();
      this.fileCollectionStack = new Array<any>();
      this.fileCollectionValidation = new Array<any>();
    }

    for (let index = 0; index < fileList.length; index++) {
      let file: any = fileList[index];
      let isFileExists = false;

      if (this.fileCollection.length > 0) {
        isFileExists = this.fileCollection.filter(item => item.fileName == file['name']).length != 0 ? true : false;
      }

      if (!isFileExists) {
        this.loaderService.isLoading.next(true);
        switch (this.libraryNumber) {
          case FileUploadLibrary.Documents:
          case FileUploadLibrary.WorkflowDocument:
            this.pushFileCollection(file, isFlushArray, index);
            break;
          case FileUploadLibrary.SignedDocuments:
            this.pushSignedDocumentsFileCollection(file, isFlushArray, index);
            break;
          case FileUploadLibrary.CCNDocuments:
            this.pushCCNDocumentsFileCollection(file, isFlushArray, index);
            break;
          case FileUploadLibrary.Communication:
            this.pushCommunicationDocumentsFileCollection(file, isFlushArray, index);
            break;
        }
      }
    }
    await this.validateFile();
  }

  private validateFile = async () => {
    this._fileService.ValidateFiles({ libraryNumber: this.libraryNumber, value: JSON.stringify(this.fileCollectionValidation) }).toPromise().then(x => {
      let returnData = x['fileCollection'];
      for (let index = 0; index < returnData['length']; index++) {
        this.fileCollection[index].fileSizeExists = returnData[index].fileSizeExists;
        this.fileCollection[index].isUploaded = returnData[index].isUploaded;
        this.fileCollection[index].progress = returnData[index].progress;
        this.fileCollection[index].status = returnData[index].status;
        this.fileCollection[index].fileType = returnData[index].fileType;
        this.fileCollection[index].fileName = returnData[index].fileName;
        this.fileCollection[index].displayFileName = returnData[index].fileName.length > 25 ? returnData[index].fileName.substring(0, 25) + '...' : returnData[index].fileName;

        if (this.fileCollection[index].progress == 100) {
          this.onUploadFinished.emit(this.fileCollection[index]);
        }
      }
      for (let index = 0; index < this.fileCollection.length; index++) {
        if (this.fileCollection[index].isLargeFile && this.fileCollection[index].status == "Initiated") {
          let totalPackets = ~~(this.fileCollection[index].fileSize / environment.maxFileSizeToUpload);
          this.fileCollection[index].totalPackets = (this.fileCollection[index].fileSize - (environment.maxFileSizeToUpload * totalPackets)) > 0 ? (totalPackets + 1) : totalPackets;
        }
      }

      this.fileCollection = this.getUnique(this.fileCollection, 'fileName');

      this.loaderService.isLoading.next(false);
    });
  }

  private getUnique(arr: any[], comp: string) {
    return arr.map(e => e[comp]).map((e, i, final) => final.indexOf(e) === i && i).filter((e: any) => arr[e]).map((e: any) => arr[e]);
  }

  public formatSizeUnits = (bytes: any) => {
    if (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
    else if (bytes >= 1048576) { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
    else if (bytes >= 1024) { bytes = (bytes / 1024).toFixed(2) + " KB"; }
    else if (bytes > 1) { bytes = bytes + " bytes"; }
    else if (bytes == 1) { bytes = bytes + " byte"; }
    else { bytes = "0 bytes"; }
    return bytes;
  }

  public isDisabled = () => {
    if (this.fileCollection.filter(item => item.isLargeFile && item.progress < 100).length > 0)
      return true;
    else
      return (this.fileCollection.filter(item => item.progress < 100).length) > 1 ? false : true;
  }

  public deleteFile = (fileIndex: any) => {
    this.fileCollection = this.fileCollection.filter(item => item.fileIndex != fileIndex);
    this.fileCollectionStack = this.fileCollectionStack.filter(item => item.fileIndex != fileIndex);
    this.fileCollectionValidation = this.fileCollectionValidation.filter(item => item.fileIndex != fileIndex);

    for (let index = 0; index < this.fileCollection.length; index++) {
      this.fileCollection[index].fileIndex = index;
      this.fileCollectionStack[index].fileIndex = index;
      this.fileCollectionValidation[index].fileIndex = index;
    }
  }

  public createTranslateJob(selectedFile: any) {
    let fileName: string = selectedFile.fileName;
    let fileExtn: string = fileName.substring(fileName.lastIndexOf(".") + 1);
    if (this.drawingFileFormats.filter(x => x == fileExtn).length > 0) {
      this._docViewerService.CreateTranslateJob({
        projectId: selectedFile.projectId, docId: selectedFile.docId, revisionNo: selectedFile.revisionNo,
        fileName: selectedFile.fileName, extension: fileExtn
      }).subscribe(res => {
      }, err => { })
    }
  }

  public async upload(fileIndex: number) {
    this.isfileUpload = true;
    let selectedFile = this.fileCollection.filter(item => item.fileIndex == fileIndex)[0];
    if (selectedFile && selectedFile.progress != 100 && selectedFile.status == "Initiated") {
      await this.processChunkUpload(selectedFile);
    }
    this.isfileUpload = false;  
  }

  public autoMapDocuments(fileList: any, DocumentList: any) {
    const docMap = new Array(fileList.length);
    for (let index = 0; index < fileList.length; index++) {
      const fileName: string = fileList[index].name;
      let isMatched = false;
      for (let i = 0; i < DocumentList.length; i++) {
        const selectedFileText = DocumentList[i].text;
        if (fileName.includes(selectedFileText)) {
          isMatched = true;
          docMap[index] = DocumentList[i].value;
          break;
        }
      }
      if (!isMatched) {
        docMap[index] = ''; 
      }
    }
    this.selecteDocument = docMap;
  }
  
  
  

  public async uploadAll() {
    for (let index = 0; index < this.fileCollection.length; index++) {
      let selectedFile = this.fileCollection.filter(item => item.fileIndex == index)[0];
      if (selectedFile && selectedFile.progress != 100 && selectedFile.status == "Initiated") {
        await this.processChunkUpload(selectedFile);
      }
    }
  }

  private async processChunkUpload(fileInfo: any) {
    let hasError: boolean = false;
    switch (this.libraryNumber) {
      case FileUploadLibrary.Documents:
      case FileUploadLibrary.WorkflowDocument:
        if (!fileInfo.docId || !fileInfo.revisionNo) {
          hasError = true;
        }
        break;
      case FileUploadLibrary.SignedDocuments:
        if (!fileInfo.docId || !fileInfo.revisionNo) {
          hasError = true;
        }
        break;
      case FileUploadLibrary.CCNDocuments:
        if (!fileInfo.ccnId || !fileInfo.revisionNo) {
          hasError = true;
        }
        break;
      case FileUploadLibrary.Communication:
        if (!fileInfo.msgId) {
          hasError = true;
        }
        break;
    }

    if (hasError) {
      return
    }

    let isFileUploaded: boolean = false;
    let _fileName = fileInfo.fileName;
    let file: File = fileInfo.file;
    let chunkSize: number = 100 * 1024 * 1024; //100 MB
    let reminder: number = file.size % chunkSize;
    let numberOfChunks: number = Math.ceil(file.size / chunkSize);
    let isAppend = false;
    if (file.size > 100 * 1024 * 1024 && reminder > 0 && reminder < 2 * 1024 * 1024) {
      isAppend = true;
    }
    numberOfChunks = isAppend ? numberOfChunks - 1 : numberOfChunks;
    for (let chunkPos = 0; chunkPos < numberOfChunks; chunkPos++) {
      const formData: FormData = new FormData();
      fileInfo.isLastChunk = chunkPos == numberOfChunks - 1
      fileInfo.chunkPosition = chunkPos;
      fileInfo.task_SNo = this.documentList[0].task_SNo >= 0 ? this.documentList[0].task_SNo : null;
      let start: number = chunkPos * chunkSize;
      let end = Math.min(file.size, (chunkPos + 1) * chunkSize);
      if (fileInfo.isLastChunk && isAppend) {
        end = file.size;
      }
      fileInfo.contentRange = "bytes " + start + "-" + (end - 1) + "/" + file.size;
      formData.append('libraryNumber', this.libraryNumber.toString())
      formData.append('fileInfo', JSON.stringify(fileInfo))
      formData.append('fileChunk', file.slice(start, end), _fileName);
      await this._fileService.UploadChunkFile(formData).toPromise().then(async (res: StandardOutputModel) => {
        if (res.successCode == 200) {
          fileInfo.fileSizeExists += chunkSize;
          fileInfo.progress = Math.ceil((fileInfo.fileSizeExists / file.size) * 100);
          if (fileInfo.isLastChunk) {
            //Disable loader
            this.loaderService.isExternalLoading.next(true);
            let maxTryCount: number = 0;
            fileInfo.fileAsByteArray = [];
            while (!isFileUploaded && maxTryCount <= 3) {
              await this._fileService.GetFileUploadStatus({ libraryNumber: this.libraryNumber, value: JSON.stringify(fileInfo) }).toPromise().then((res: StandardOutputModel) => {
                if (res.successCode == 200 && res.result == "100") {
                  this.onUploadFinished.emit(fileInfo);
                  isFileUploaded = true;
                  fileInfo.progress = 100;
                  this._notificationService.showToast(_fileName + " - uploaded successfully", "Success");
                  //Enable loader back to default functionality
                  this.loaderService.isExternalLoading.next(false);
                  if (this.isTranslationRequired) {
                    setTimeout(() => {
                      this.createTranslateJob(fileInfo);
                    }, 3000);
                  }
                }
              });
              if (!isFileUploaded) {
                maxTryCount++;
                await this.delay(4000);
              }
            }
            if (!isFileUploaded) {
              //Enable loader back to default functionality
              this.loaderService.isExternalLoading.next(false);
              this._notificationService.showToast(_fileName + " - failed to upload", "Warning");
            }
          }
        }
        else {
          this._notificationService.showPopup(_fileName + " - failed to upload", "Warning");
        }
      }, err => {
        this._notificationService.showPopup(_fileName + " - failed to upload", "Warning");
      })
    }
  }

  private delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public getFileType() {
    let reqData = { "DEDescription": "File Type" };
    return this.restAPIService.new_POST(this.uris.dedAgainstDEGetUrl, reqData).subscribe(data => {
      this.fileTypeList = data;
    });
  }

  public onChange_FileType(event: { value: any; }, rowIndex: any, dataItem: any) {
    this.fileCollection.filter(item => item.fileIndex == rowIndex)[0].fileType = event.value;
  }

  public onChange_Document(event: { value: number; }, rowIndex: any, dataItem: { fileIndex: any; }) {
    if (this.isDocumentListDisabled && this.documentList.length > 1) {
      let _selectedDocument = this.documentList.filter(item => item.value == event.value)[0];
      let _selectedFile = this.fileCollection.filter(item => item.fileIndex == dataItem.fileIndex)[0];

      if (event.value != -2 && _selectedDocument && _selectedFile) {
        _selectedFile.docId = _selectedDocument.value;
        _selectedFile.revisionNo = _selectedDocument.revisionNo;
      }

      if (event.value == -2 && _selectedFile) {
        _selectedFile.docId = 0;
        _selectedFile.revisionNo = "";
      }
    }
  }

  private pushFileCollection(file: any, isFlushArray: boolean, index: number) {
    let fileContents = null;
    this.fileCollectionValidation.push({
      fileIndex: isFlushArray ? index : this.fileCollection.length,
      fileName: file['name'],
      displayFileName: file['name'].length > 25 ? file['name'].substring(0, 25) + '...' : file['name'],
      fileSize: file['size'],
      fileSizeExists: 0,
      lastModifiedDate: file['lastModifiedDate'],
      progress: 0,
      status: 'Initiated',
      isUploaded: false,
      projectId: this.data['projectId'],
      docId: this.data['docId'],
      revisionNo: this.data['revisionNo'],
      createdBy: this.data['createdBy'],
      fileType: this.getDefaultAPI(),
      fileCategory: 0
    });

    this.fileCollection.push({
      fileIndex: isFlushArray ? index : this.fileCollection.length,
      fileName: file['name'],
      displayFileName: file['name'].length > 25 ? file['name'].substring(0, 25) + '...' : file['name'],
      fileSize: file['size'],
      fileSizeExists: 0,
      fileAsByteArray: fileContents,
      file: file,
      lastModifiedDate: file['lastModifiedDate'],
      progress: 0,
      status: 'Initiated',
      isLargeFile: file['size'] >= environment.maxFileSizeToUpload ? true : false,
      currentPacket: 0,
      totalPackets: 1,
      isUploaded: false,
      projectId: this.data['projectId'],
      docId: this.data['docId'],
      revisionNo: this.data['revisionNo'],
      createdBy: this.data['createdBy'],
      fileType: this.getDefaultAPI(),
      fileCategory: 0
    });

    this.fileCollectionStack.push({
      fileIndex: isFlushArray ? index : this.fileCollectionStack.length,
      fileAsByteArray: fileContents
    });
  }

  private pushSignedDocumentsFileCollection(file: any, isFlushArray: boolean, index: number) {
    let fileContents = null;
    this.fileCollectionValidation.push({
      fileIndex: isFlushArray ? index : this.fileCollection.length,
      fileName: file['name'],
      displayFileName: file['name'].length > 25 ? file['name'].substring(0, 25) + '...' : file['name'],
      fileSize: file['size'],
      fileSizeExists: 0,
      lastModifiedDate: file['lastModifiedDate'],
      progress: 0,
      status: 'Initiated',
      isUploaded: false,
      projectId: this.data['projectId'],
      msgId: this.data['msgId'],
      docId: this.data['docId'],
      revisionNo: this.data['revisionNo'],
      createdBy: this.data['createdBy'],
      fileType: this.getDefaultAPI(),
      fileCategory: 0
    });

    this.fileCollection.push({
      fileIndex: isFlushArray ? index : this.fileCollection.length,
      fileName: file['name'],
      displayFileName: file['name'].length > 25 ? file['name'].substring(0, 25) + '...' : file['name'],
      fileSize: file['size'],
      fileSizeExists: 0,
      fileAsByteArray: fileContents,
      file: file,
      lastModifiedDate: file['lastModifiedDate'],
      progress: 0,
      status: 'Initiated',
      isLargeFile: file['size'] >= environment.maxFileSizeToUpload ? true : false,
      currentPacket: 0,
      totalPackets: 1,
      isUploaded: false,
      projectId: this.data['projectId'],
      msgId: this.data['msgId'],
      docId: this.data['docId'],
      revisionNo: this.data['revisionNo'],
      createdBy: this.data['createdBy'],
      fileType: this.getDefaultAPI(),
      fileCategory: 0
    });

    this.fileCollectionStack.push({
      fileIndex: isFlushArray ? index : this.fileCollectionStack.length,
      fileAsByteArray: fileContents
    });
  }

  private pushCCNDocumentsFileCollection(file: any, isFlushArray: boolean, index: number) {
    let fileContents = null;
    this.fileCollectionValidation.push({
      fileIndex: isFlushArray ? index : this.fileCollection.length,
      fileName: file['name'],
      displayFileName: file['name'].length > 25 ? file['name'].substring(0, 25) + '...' : file['name'],
      fileSize: file['size'],
      fileSizeExists: 0,
      lastModifiedDate: file['lastModifiedDate'],
      progress: 0,
      status: 'Initiated',
      isUploaded: false,
      projectId: this.data['projectId'],
      ccnId: this.data['ccnId'],
      revisionNo: this.data['revisionNo'],
      createdBy: this.data['createdBy'],
      fileType: this.getDefaultAPI(),
      fileCategory: 0
    });

    this.fileCollection.push({
      fileIndex: isFlushArray ? index : this.fileCollection.length,
      fileName: file['name'],
      displayFileName: file['name'].length > 25 ? file['name'].substring(0, 25) + '...' : file['name'],
      fileSize: file['size'],
      fileSizeExists: 0,
      fileAsByteArray: fileContents,
      file: file,
      lastModifiedDate: file['lastModifiedDate'],
      progress: 0,
      status: 'Initiated',
      isLargeFile: file['size'] >= environment.maxFileSizeToUpload ? true : false,
      currentPacket: 0,
      totalPackets: 1,
      isUploaded: false,
      projectId: this.data['projectId'],
      ccnId: this.data['ccnId'],
      revisionNo: this.data['revisionNo'],
      createdBy: this.data['createdBy'],
      fileType: this.getDefaultAPI(),
      fileCategory: 0
    });

    this.fileCollectionStack.push({
      fileIndex: isFlushArray ? index : this.fileCollectionStack.length,
      fileAsByteArray: fileContents
    });
  }

  private pushCommunicationDocumentsFileCollection(file: any, isFlushArray: boolean, index: number) {
    let fileContents = null;
    this.fileCollectionValidation.push({
      fileIndex: isFlushArray ? index : this.fileCollection.length,
      fileName: file['name'],
      displayFileName: file['name'].length > 25 ? file['name'].substring(0, 25) + '...' : file['name'],
      fileSize: file['size'],
      fileSizeExists: 0,
      lastModifiedDate: file['lastModifiedDate'],
      progress: 0,
      status: 'Initiated',
      isUploaded: false,
      projectId: this.data['projectId'],
      msgId: this.data['msgId'],
      createdBy: this.data['createdBy'],
      fileType: this.getDefaultAPI(),
      fileCategory: 0
    });

    this.fileCollection.push({
      fileIndex: isFlushArray ? index : this.fileCollection.length,
      fileName: file['name'],
      displayFileName: file['name'].length > 25 ? file['name'].substring(0, 25) + '...' : file['name'],
      fileSize: file['size'],
      fileSizeExists: 0,
      fileAsByteArray: fileContents,
      file: file,
      lastModifiedDate: file['lastModifiedDate'],
      progress: 0,
      status: 'Initiated',
      isLargeFile: file['size'] >= environment.maxFileSizeToUpload ? true : false,
      currentPacket: 0,
      totalPackets: 1,
      isUploaded: false,
      projectId: this.data['projectId'],
      msgId: this.data['msgId'],
      createdBy: this.data['createdBy'],
      fileType: this.getDefaultAPI(),
      fileCategory: 0
    });

    this.fileCollectionStack.push({
      fileIndex: isFlushArray ? index : this.fileCollectionStack.length,
      fileAsByteArray: fileContents
    });
  }

  public getDefaultAPI(): number {
    var data = this.fileTypeList.filter(item => item.dedDescription.toLocaleLowerCase() == 'support');
    return data.length > 0 ? data[0].dedId : 0;
  }

}